import React, {useEffect} from 'react';

import {hooks} from '../../hooks';
import {components} from '../../components';
import {actions} from '../../store/actions';
import {salon} from '../../config/salon';

export const Contact: React.FC = () => {
  const dispatch = hooks.useDispatch();

  hooks.useThemeColor('#FFF7F4');

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(actions.setColor('#FFF7F4'));
  }, [dispatch]);

  return (
    <>
      <components.Header
        title='İletişim'
        showLogo={true}
        showBasket={true}
        headerStyle={{backgroundColor: 'var(--main-background)'}}
      />
      <main className='scrollable salon-main salon-main--quiet'>
        <components.HeroSlider />
        <section className='salon-section'>
          <span className='salon-eyebrow'>Randevu</span>
          <h2>Hızlı İletişim</h2>
          <p className='salon-section__text'>
            Randevu ve işlem detayları için telefon ya da WhatsApp üzerinden
            ulaşabilirsiniz.
          </p>
          <div className='salon-actions'>
            <a
              className='salon-button salon-button--dark'
              href={salon.phoneHref}
            >
              Hemen Ara
            </a>
            <a
              className='salon-button salon-button--outline'
              href={salon.whatsappHref}
              target='_blank'
              rel='noreferrer'
            >
              WhatsApp
            </a>
          </div>
        </section>
        <section className='salon-section'>
          <div className='salon-info-grid'>
            <article className='salon-contact-card'>
              <h3>Telefon</h3>
              <p>
                <a href={salon.phoneHref}>{salon.phone}</a>
              </p>
            </article>
            <article className='salon-contact-card'>
              <h3>Instagram</h3>
              <p>
                <a
                  href={salon.instagramHref}
                  target='_blank'
                  rel='noreferrer'
                >
                  {salon.instagramHandle}
                </a>
              </p>
            </article>
            <article className='salon-contact-card'>
              <h3>Adres</h3>
              <p>
                <a
                  href={salon.mapsHref}
                  target='_blank'
                  rel='noreferrer'
                >
                  {salon.address}
                </a>
              </p>
            </article>
          </div>
        </section>
      </main>
      <components.QuickContact />
      <components.Footer />
    </>
  );
};
